<div class="announcements-panel">
  <div class="announcements-header">
    <h2 class="section-header dashboard-section-header">
      Recent JFW Announcements &amp; Policy Updates
    </h2>
    <mat-checkbox
      [checked]="includeArchives"
      (change)="toggleIncludeArchives($event.checked)"
    >
      Include Archives
    </mat-checkbox>
  </div>

  @if (loading()) {
    <p>Loading...</p>
  } @else if (error()) {
    <p class="error-text">Unable to load announcements right now.</p>
  } @else if (!announcementsPage()?.items?.length) {
    <p class="empty-text">No announcements to show.</p>
  } @else {
    <div class="announcements-table-wrapper">
    <table class="announcements-table">
      <thead>
        <tr>
          <th class="table-header">Published</th>
          <th class="table-header">Note</th>
          <th class="table-header">Read</th>
          <th class="table-header"></th>
        </tr>
      </thead>
      <tbody>
        @for (item of announcementsPage()?.items; track item.id; let i = $index) {
          <tr [class.alt-row]="i % 2 === 1" [class.unread]="!item.readDate">
            <td class="table-cell">{{ formatPublishedDate(item.publishedDate) }}</td>
            <td class="table-cell">
              <a href="javascript:void(0)" (click)="openLink(item)">{{ item.noteText }}</a>
            </td>
            <td class="table-cell">
              @if (item.readDate) {
                <mat-icon
                  class="read-icon"
                  matTooltip="Read {{ formatPublishedDate(item.readDate) }}"
                  >check_circle</mat-icon
                >
              }
            </td>
            <td class="table-cell action-cell">
              @if (item.isArchived) {
                <button mat-button (click)="restore(item)">Restore</button>
              } @else {
                <button mat-button (click)="archive(item)">Archive</button>
              }
            </td>
          </tr>
        }
      </tbody>
    </table>

    <mat-paginator
      [pageSizeOptions]="[pageSize]"
      [pageSize]="pageSize"
      [length]="totalCount()"
      [hidePageSize]="true"
      aria-label="Select page of announcements"
      (page)="onPage($event)"
    ></mat-paginator>
    </div>
  }
</div>
